<template>
  <b-modal
      :id="modalUUid"
      :ref="modalUUid"
      size="lg"
      hide-footer
      title="Database View"
      @show="isModalOpen = true"
      @hidden="isModalOpen = false"
      @shown="populateTable"
  >
    <base-table
      ref="table"
      :fields="fields"
      :filterSettings="{}"
      :disableHeader="true"
      :hideSearch="true"
      :isFrontendPagination="true"
      :showPagination="false"
      :firstSearch="false"
      :showSpinner="false"
      :useSpinnerLoading="false"
      url=""
    >
      <template #cell(column)="item">
        <span class="text-nowrap">{{ item.value }}</span>
      </template>
      <template #cell(value)="item">
        <span class="word-pre-wrap">{{ formatValue(item.value) }}</span>
      </template>
    </base-table>
  </b-modal>
</template>

<script>
export default {
  props: {
    data: {
      required: true
    },
    id: {
      required: true
    }
  },
  computed: {
    rows () {
      const normalize = (val) => {
        if (val === null || val === undefined) return '-'
        if (typeof val === 'object') return JSON.stringify(val, null, 2)
        return val
      }
      if (Array.isArray(this.data)) {
        return this.data.map((val, idx) => ({ column: idx, value: normalize(val) }))
      }
      if (this.data && typeof this.data === 'object') {
        return Object.entries(this.data).map(([key, val]) => ({ column: key, value: normalize(val) }))
      }
      return [{ column: 'value', value: normalize(this.data) }]
    }
  },
  data () {
    return {
      isModalOpen: false,
      modalUUid: `database-view-modal${this.id}-${Math.random().toString(36).substr(2, 9)}`,
      fields: [
        { label: 'Column', key: 'column', sortable: true },
        { label: 'Value', key: 'value', sortable: false }
      ]
    }
  },
  watch: {
    data () {
      if (this.isModalOpen) this.$nextTick(() => this.populateTable())
    }
  },
  methods: {
    showModal () {
      this.$bvModal.show(this.modalUUid)
    },
    populateTable () {
      if (this.$refs.table) {
        const rows = this.rows
        this.$refs.table.params.page = 1
        this.$refs.table.allItems = rows
        this.$refs.table.items = rows
      }
    },
    formatValue (val) {
      if (val === null || val === undefined) return '-'
      if (typeof val === 'object') return JSON.stringify(val, null, 2)
      return val
    }
  }
}
</script>
<style scoped>
  .word-pre-wrap {
    word-break: break-word;
    white-space: pre-wrap;
  }
</style>